import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/Logo";
import { toast } from "sonner";
import { Lock, Mail, Loader2, ShieldCheck } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1728102596258-7c6124fe22cc?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState(params.get("email") || "");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) { toast.success("Sessão iniciada"); navigate("/painel"); }
    else toast.error(res.error || "Falha no início de sessão");
  };

  return (
    <div className="min-h-screen flex bg-[#0D1B2A]">
      <div className="hidden lg:flex w-1/2 relative">
        <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(120deg, rgba(13,27,42,0.95) 0%, rgba(13,27,42,0.6) 100%)" }} />
        <div className="relative z-10 flex flex-col justify-between p-12">
          <Logo size="lg" showText />
          <div>
            <h2 className="font-display text-4xl text-white leading-tight">CRM Imobiliário<br /><span className="gold-text">de Alta Gama</span></h2>
            <p className="mt-4 text-slate-300 max-w-md">Gestão de leads, bolsa de procura confidencial, desempenho e financeiro — a plataforma proprietária do Grupo Almar Investimentos.</p>
          </div>
          <p className="text-xs text-slate-500 tracking-widest uppercase">© Grupo Almar Investimentos</p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-6 ambient-glow">
        <div className="w-full max-w-md">
          <div className="lg:hidden flex justify-center mb-8"><Logo size="lg" showText /></div>
          <a href="/" data-testid="back-to-site-link" className="block text-center text-xs text-slate-400 hover:text-[#E0C574] mb-4">← Voltar ao site</a>
          <div className="card-almar p-8 shadow-2xl" style={{ borderColor: "rgba(201,168,76,0.4)" }} data-testid="login-card">
            <h1 className="font-display text-2xl text-[#C9A84C] mb-1">Iniciar Sessão</h1>
            <p className="text-sm text-slate-400 mb-6">Aceda à sua conta de consultor</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="text-xs uppercase tracking-wider text-[#C9A84C] font-medium">Email</label>
                <div className="relative mt-1.5">
                  <Mail size={17} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
                  <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                    className="input-almar pl-10" placeholder="nome@grupoalmar.pt" data-testid="login-email-input" />
                </div>
              </div>
              <div>
                <label className="text-xs uppercase tracking-wider text-[#C9A84C] font-medium">Palavra-passe</label>
                <div className="relative mt-1.5">
                  <Lock size={17} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
                  <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                    className="input-almar pl-10" placeholder="••••••••" data-testid="login-password-input" />
                </div>
              </div>
              <button type="submit" disabled={loading} data-testid="login-submit-button"
                className="w-full flex items-center justify-center gap-2 bg-[#C9A84C] hover:bg-[#D9B85C] text-[#0D1B2A] font-semibold py-3 rounded-lg shadow-[0_4px_14px_rgba(201,168,76,0.3)] transition-all hover:scale-[1.01] active:scale-[0.99] disabled:opacity-60">
                {loading ? <Loader2 size={18} className="animate-spin" /> : <ShieldCheck size={18} />}
                {loading ? "A entrar..." : "Entrar"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
